exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._9uDKzalrxSrnF-EuqB-t1{font-size:1.25em;font-weight:700;margin:1em 0}", ""]);

// exports
exports.locals = {
	"Group_title": "_9uDKzalrxSrnF-EuqB-t1"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/style.postcss
// module id = 1223
// module chunks = 0